const wowApp = require('angular').module('wowApp.shop');

wowApp.service('OrderTrackerService', ['$rootScope', '$state', 'ShopperService', '$timeout', require('./order-tracker-service')])
      .directive('orderTracker', ['OrderTrackerService', 'ShopLocatorService', '$anchorScroll', require('./order-tracker-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/order-tracker/index.js
 **/